import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Row, Col } from 'react-bootstrap';
import TableList from '../../components/TableList';
import { ContextMenu } from 'components/context-menu/context-menu';
import { MessengerBox } from 'components/messenger-box/messenger-box';
import { CheckBox } from 'components/checkboxes/check-box';
import { Popup } from 'components/Popup/popup';
import * as AppSettings from 'constants';
import * as UnitHelper from 'helper/unit-helper';
import * as InsurancePolicyActionType from '../constants';
import { AddEditInsurancePolicy } from '../Components/add-edit-insurance-policy';

const defaultParams = {
  defaultSortName: 'name',
  defaultSortOrder: 'ascending',
  sizePerPage: 10
};

const TABLE_NAME = 'INSURANCE_POLICIES_LIST';

class ManageInsurancePolicy extends Component {
  static propTypes = {
    history: PropTypes.object,
    dispatch: PropTypes.func,
    InsurancePolicyStore: PropTypes.object,
    PageSizeReference: PropTypes.object
  };
  constructor(props) {
    super(props);

    this.sizePerPage = UnitHelper.initialSizePerPage(
      TABLE_NAME,
      props.PageSizeReference,
      props.InsurancePolicyStore.ManageInsurancePolicies.params.take
    );

    this.state = {
      defaultSortName: defaultParams.defaultSortName, // default sort column name
      defaultSortOrder: defaultParams.defaultSortOrder, // default sort order,
      currentPage:
        props.InsurancePolicyStore.ManageInsurancePolicies.params.skip,
      sizePerPage: this.sizePerPage,
      totalRecord:
        props.InsurancePolicyStore.ManageInsurancePolicies.params.totalRecord,
      data: props.InsurancePolicyStore.ManageInsurancePolicies.items,
      status: props.InsurancePolicyStore.ManageInsurancePolicies.params.status,
      showModal: false,
      isShowPopup: false,
      checkedValues: ['active', 'inActive']
    };
  }

  componentDidMount() {
    this.binding(
      this.objToParams({
        ...this.props.InsurancePolicyStore.ManageInsurancePolicies.params,
        take: this.state.sizePerPage
      })
    );

    const self = this;
    window.addEventListener('click', e => {
      if (
        document.getElementById('s1-popup') &&
        document.getElementById('s1-popup').contains(e.target)
      ) {
        // Clicked in box
      } else {
        // Clicked outside the box
        if (
          document.getElementById('popup-button') &&
          document.getElementById('popup-button').contains(e.target)
        ) {
          // clicked in box
        } else {
          if (self.state.isShowPopup) {
            self.setState({ isShowPopup: false });
          }
        }
      }
    });
  }

  componentWillReceiveProps(nextProps) {
    const {
      InsurancePolicyStore: { ManageInsurancePolicies }
    } = nextProps;
    if (ManageInsurancePolicies) {
      this.setState({
        totalRecord: ManageInsurancePolicies.params.totalRecord,
        currentPage: ManageInsurancePolicies.params.skip,
        data: nextProps.InsurancePolicyStore.ManageInsurancePolicies.items
      });
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.sizePerPage !== this.state.sizePerPage) {
      UnitHelper.dispatchActionSetPageSizeReference(
        this.props.dispatch,
        TABLE_NAME,
        this.state.sizePerPage
      );
    }
  }

  componentWillUnmount() {
    this.props.dispatch({
      type: InsurancePolicyActionType.RESET_INSURANCE_POLICY,
      params: null
    });
  }

  customRenderName(item) {
    var style = {};

    if (!item.isActive) {
      style = { opacity: 0.5 };
    }

    return <span style={style}>{item.name}</span>;
  }

  customRenderBtnAction(item) {
    return (
      <a
        className='glyphicon glyphicon-option-vertical cls-table-black-icon'
        onClick={e => {
          this.onContextMenu(e, item);
        }}
      />
    );
  }

  trClassFormat = row => {
    if (row && row.status === 0) {
      return 'colm-inactive';
    }
    return '';
  };

  binding(params) {
    this.props.dispatch({
      type: InsurancePolicyActionType.SEARCH_INSURANCE_POLICY_ASYNC,
      params: params
    });
  }

  onContextMenu(e, item) {
    var contextItem = [
      {
        title: 'Edit',
        icon: 'glyphicon glyphicon-pencil',
        event: this.onOpenAddEditPopup.bind(this)
      }
    ];

    if (item.status) {
      contextItem.push({
        title: 'Make inactive',
        icon: 'glyphicon glyphicon-minus-sign',
        event: this.onMakeInActive.bind(this)
      });
    } else {
      contextItem.push({
        title: 'Make active',
        icon: 'glyphicon glyphicon-ok-sign',
        event: this.onMakeActive.bind(this)
      });
    }

    this.cxtMenu.state.event(e, item, contextItem);
  }

  onViewAssociatedItemsToRepair(e, item) {
    this.props.history.push(`/items/${item.name}`);
  }

  onMakeInActive(e, item) {
    this.onSave(
      e,
      item.id,
      InsurancePolicyActionType.MAKE_INACTIVE_INSURANCE_POLICY_ASYNC
    );
  }

  onMakeActive(e, item) {
    this.onSave(
      e,
      item.id,
      InsurancePolicyActionType.MAKE_ACTIVE_INSURANCE_POLICY_ASYNC
    );
  }

  onTableBinding(configTable) {
    var params = this.objToParams(
      this.props.InsurancePolicyStore.ManageInsurancePolicies.params
    );
    this.binding({
      ...params,
      sortField: configTable.sort.field,
      sortOrder: configTable.sort.order,
      skip: configTable.page.skip - 1,
      take: configTable.page.take
    });
  }

  onSave(e, data, insurancePolicyActionType) {
    var params = {
      ...this.objToParams(
        this.props.InsurancePolicyStore.ManageInsurancePolicies.params
      ),
      searchKey: ''
    };
    this.props.dispatch({
      type: insurancePolicyActionType,
      params: {
        data: data,
        search: params
      }
    });
  }

  onOpenAddEditPopup(e, item) {
    if (typeof item === 'undefined') {
      this.props.dispatch({
        type: InsurancePolicyActionType.OPEN_FORM_CREATE_INSURANCE_POLICY,
        params: null
      });
      // this.setState({ showModal: true });
    } else {
      this.props.dispatch({
        type: InsurancePolicyActionType.GET_INSURANCE_POLICY_BY_ID_ASYNC,
        params: item.id
      });
      // this.setState({ showModal: this.props.isOpenFormAddEdit });
    }
  }

  onCloseModal = () => {
    this.props.dispatch({
      type: InsurancePolicyActionType.CLOSE_FORM_CREATE_INSURANCE_POLICY,
      params: null
    });
  };

  handleChange = (e, value) => {
    if (this.state.checkedValues.includes(value)) {
      this.setState(
        {
          checkedValues: [
            ...this.state.checkedValues.filter(item => item !== value).sort()
          ]
        },
        () => {
          this.onChecked(e, this.state.checkedValues);
        }
      );
    } else {
      this.setState(
        {
          checkedValues: [...this.state.checkedValues, value].sort()
        },
        () => {
          this.onChecked(e, this.state.checkedValues);
        }
      );
    }
  };

  onTogglePopupFilter = () => {
    this.setState({
      isShowPopup: !this.state.isShowPopup
    });
  };

  onChecked(e, data) {
    var status = UnitHelper.isEmpty(data.toString()) ? '' : data.toString();

    if (status !== '') {
      var params = this.objToParams(
        this.props.InsurancePolicyStore.ManageInsurancePolicies.params
      );
      if (status.includes('active,inActive')) {
        status = 'all';
      }
      this.binding({
        ...params,
        status: status,
        skip: 0
      });
    } else {
      this.setState({ data: [] });
    }
  }

  objToParams(obj) {
    return {
      searchKey: '',
      sortField: obj.sort.field,
      sortOrder: obj.sort.order,
      status: obj.status,
      skip: obj.skip - 1,
      take: obj.take
    };
  }

  handleCloseModal = () => {
    this.setState({ showModal: false });
  };

  refreshList(params) {
    this.setState(
      {
        defaultSortName: params.defaultSortName,
        defaultSortOrder: params.defaultSortOrder,
        sizePerPage: params.sizePerPage
      },
      () => {
        this.props.dispatch({
          type: InsurancePolicyActionType.SEARCH_INSURANCE_POLICY_ASYNC,
          params: {
            searchKey: '',
            sortField: params.defaultSortName,
            sortOrder: params.defaultSortOrder,
            status: this.state.status,
            skip: params.currentPage - 1,
            take: params.sizePerPage
          }
        });
      }
    );
  }

  render() {
    const column = [
      {
        field: 'id',
        header: 'id',
        hidden: true,
        isKey: true,
        sort: false,
        dataAlign: 'left',
        headerAlign: 'left'
      },
      {
        field: 'name',
        header: 'Name',
        hidden: false,
        isKey: false,
        sort: true,
        dataAlign: 'left',
        headerAlign: 'left'
      },
      {
        field: '',
        header: '',
        hidden: false,
        isKey: false,
        sort: false,
        dataAlign: 'right',
        headerAlign: 'right',
        customRender: this.customRenderBtnAction.bind(this),
        className: 'column-action',
        columnClassName: 'column-action'
      }
    ];

    const { data } = this.state;

    const totalRecord = data.length > 0 ? this.state.totalRecord : 0;

    const options = {
      defaultSortName: this.state.defaultSortName, // default sort column name
      defaultSortOrder: this.state.defaultSortOrder, // default sort order,
      sizePerPage: this.state.sizePerPage,
      totalRecord: totalRecord
    };

    const customHeader = (
      <div className='table-header'>
        <Row>
          <Col sm={12} md={12} className='text-right'>
            <div className='pull-right manage-user-filter'>
              <button
                onClick={this.onTogglePopupFilter}
                className='btn btn-secondary fa fa-filter btn-icon'
                id='popup-button'
              />
              {this.state.isShowPopup && (
                <Popup
                  ref={ref => {
                    this.popup = ref;
                  }}
                >
                  <CheckBox
                    checked={this.state.checkedValues.includes('active')}
                    onChecked={this.onChecked.bind(this)}
                    name='isActive'
                    className='checkbox-default'
                    value='active'
                    label='Active'
                    handleChange={this.handleChange}
                  />
                  <CheckBox
                    checked={this.state.checkedValues.includes('inActive')}
                    onChecked={this.onChecked.bind(this)}
                    name='isActive'
                    className='checkbox-default'
                    value='inActive'
                    label='InActive'
                    handleChange={this.handleChange}
                  />
                </Popup>
              )}
            </div>
          </Col>
        </Row>
      </div>
    );

    return (
      <div id='manage-user'>
        <div className='page-title clearfix'>
          <h2 className='pull-left'>Insurance policies ({totalRecord})</h2>
          <button
            className='btn btn-primary btn-info btn-siteone pull-right btn-icon'
            onClick={this.onOpenAddEditPopup.bind(this)}
          >
            <span className='fa fa-plus icon' />
            NEW
          </button>
        </div>

        <AddEditInsurancePolicy
          item={this.props.InsurancePolicyStore.InsurancePolicyProfile}
          errorMsg={this.props.InsurancePolicyStore.ErrorMsg}
          show={this.props.InsurancePolicyStore.IsOpenFormAddEdit}
          isCreate={this.props.InsurancePolicyStore.IsCreate}
          title={this.props.InsurancePolicyStore.Title}
          onSubmit={this.onSave.bind(this)}
          onCloseModal={this.onCloseModal}
          onHide={this.handleCloseModal}
        />

        <TableList
          column={column}
          data={data}
          defaultParams={defaultParams}
          options={options}
          showButtonMenu={true}
          refreshPageList={this.refreshList.bind(this)}
          refreshList={this.refreshList.bind(this)}
          onContextMenu={this.onContextMenu.bind(this)}
          customTableHeader={customHeader}
          trClassName={this.trClassFormat}
        />

        <ContextMenu
          ref={ref => {
            this.cxtMenu = ref;
          }}
        />
        <MessengerBox
          ref={ref => {
            this.msgBox = ref;
          }}
          title={AppSettings.COMPANY_NAME}
        />
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    InsurancePolicyStore: state.InsurancePolicyStore,
    PageSizeReference: state.BuilderStore.PageSizeReference
  };
};

export default connect(mapStateToProps)(ManageInsurancePolicy);



// WEBPACK FOOTER //
// ./src/Insurance/Containers/manage-insurance-policies.js